import { Box, Spinner } from "@chakra-ui/react";
import { useAppTheme } from "../ThemeContext.tsx";

const Loading = () => {
  const { resolvedTheme } = useAppTheme();
  const isDark = resolvedTheme === "dark";
  const bgColor = isDark ? "gray.800" : "gray.100";
  const spinnerColor = isDark ? "gray.500" : "gray.600";
  const emptyColor = isDark ? "gray.200" : "gray.400";

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bg={bgColor}
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor={emptyColor}
        color={spinnerColor}
        size="xl"
      />
    </Box>
  );
};

export default Loading;
